class HeroDemoForm {
    constructor(form) {
        this.form = form;
        this.formWrapper = this.form.closest('.hero-demo-form__form-wrapper');

        this.submitButton = form.querySelector('button[type="submit"]');

        this.companyField = this.form.querySelector('[name="company_name"]');
        this.orgNumberField = this.form.querySelector('[name="org_number"]');
        this.orgNumberGroup = this.form.querySelector('[data-org-number-group]');
        this.companySuggestions = this.form.querySelector('[data-company-suggestions]');
        this.companyDataField = this.form.querySelector('[name="company_data"]');
        this.successBlock = this.formWrapper.parentNode.querySelector('[data-demo-success]');
        this.restartButton = this.successBlock.querySelector('[data-demo-restart]');

        this.companyGroup = this.companyField
            ? this.companyField.closest('.form-group')
            : null;

        this.companySelected = false;
        this.selectedCompany = null;

        this.searchController = null;
        this.companySearchTimeout = null;

        this.eventId = this.generateUUID();

        this.emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,}$/;

        this.blockedDomains = [
            'gmail.com',
            'yahoo.com',
            'hotmail.com',
            'outlook.com',
            'icloud.com',
            'aol.com',
            'proton.me',
            'protonmail.com',
        ];

        this.lang = document.body.dataset.lang || 'en';

        this.i18n = {
            'en': {
                useInstead: 'Use "{value}" instead',
            },
            'sv-se': {
                useInstead: 'Använd "{value}" istället',
            },
            'de-de': {
                useInstead: 'Verwenden Sie stattdessen "{value}"',
            },
        };

        this.init();
    }

    init() {
        this.injectEventId();
        this.injectCompanyDataField();

        this.form.addEventListener('submit', (e) => this.onSubmit(e));

        this.getRequiredFields().forEach((field) => {

            const clearError = () => {

                const group = field.closest('.form-group');

                if (group && group.classList.contains('has-error')) {
                    this.clearFieldError(field);
                }

            };

            field.addEventListener('input', clearError);
            field.addEventListener('change', clearError);

        });

        if (this.companyField) {
            this.companyField.addEventListener('input', (e) => {
                this.onCompanyInput(e.target.value);
            });

            this.companyField.addEventListener('blur', () => {
                setTimeout(() => {
                    this.handleCompanyBlur();
                }, 100);
            });
        }

        this.companyField.addEventListener('keydown', (e) => {

            if (e.key !== 'ArrowDown') {
                return;
            }

            const first = this.companySuggestions.querySelector('[data-company-item], [data-company-custom]');

            if (first) {
                e.preventDefault();
                first.focus();
            }

        });

        document.addEventListener('click', (e) => {

            if (!this.form.contains(e.target)) {
                this.hideCompanies();
            }

        });

        this.companyField.addEventListener('keydown', (e) => {

            if (e.key === 'Escape') {
                this.hideCompanies();
            }

        });

        this.restartButton.addEventListener('click', () => {
            window.location.reload();
        });
    }

    async onSubmit(e) {
        e.preventDefault();

        let isValid = true;

        this.getRequiredFields().forEach((field) => {

            if (!this.validateField(field)) {
                isValid = false;
            }

        });

        if (!isValid) {
            return;
        }

        await this.submitForm();
    }

    async submitForm() {

        const formData = new FormData(this.form);

        formData.append('action', 'sendify_demo_request_submit');
        formData.append('event_id', this.eventId);
        formData.append('page_url', window.location.href);
        formData.append('referrer', document.referrer);
        formData.append('nonce', themeVars.demo_request_nonce);

        // Analytics
        this.onSubmitSuccess();

        // Background request
        fetch(themeVars.ajaxurl, {
            method: 'POST',
            body: formData,
            credentials: 'same-origin',
        })
            .then((response) => response.json())
            .then(() => {})
            .catch((error) => {
                console.error(error);
            });
    }

    validateField(field) {

        const type = field.type;
        const value = (field.value || '').trim();

        if (field.name === 'company_name') {
            return this.validateCompany(field, value);
        }

        if (type === 'checkbox') {
            return this.validateCheckbox(field);
        }

        if (field.required && !value) {
            return this.showError(field);
        }

        if (type === 'email') {
            return this.validateEmail(field, value);
        }

        if (field.name === 'phone' || type === 'tel') {
            return this.validatePhone(field, value);
        }

        if (field.name === 'org_number') {
            return this.validateOrgNumber(field);
        }

        if (field.name === 'full_name') {
            return this.validateFullName(field, value);
        }

        return this.hideError(field);

    }

    validateCheckbox(field) {
        if (!field.checked) {
            return this.showError(field);
        }
        return this.hideError(field);
    }

    validateEmail(field, value) {
        const parts = value.split('@');
        const domain = parts[1] ? parts[1].toLowerCase() : '';
        if (!this.emailRegex.test(value) || !domain || this.blockedDomains.includes(domain)) {
            return this.showError(field);
        }
        return this.hideError(field);
    }

    validateFullName(field, value) {
        const words = value.split(' ').filter(Boolean);
        if (words.length < 2) {
            return this.showError(field);
        }
        return this.hideError(field);
    }

    validateOrgNumber(field) {

        if (!this.orgNumberGroup) {
            return true;
        }

        const isHidden = this.orgNumberGroup.classList.contains('is-hidden');

        if (isHidden) {
            return true;
        }

        if (!(field.value || '').trim()) {
            return this.showError(field);
        }

        return this.hideError(field);

    }

    validatePhone(field, value) {
        const phoneRegex = /^[+]?[\d\s().-]+$/;
        const digits = value.replace(/\D/g, '');

        if (!phoneRegex.test(value) || digits.length < 7) {
            return this.showError(field);
        }

        return this.hideError(field);
    }

    clearFieldError(field) {
        const group = field.closest('.form-group');
        if (!group) return;

        group.classList.remove('has-error');

        this.toggleSubmitButton();
    }

    showError(field) {
        const group = field.closest('.form-group');

        if (group) {
            group.classList.add('has-error');
        }

        this.toggleSubmitButton();

        return false;
    }

    hideError(field) {
        const group = field.closest('.form-group');

        if (group) {
            group.classList.remove('has-error');
        }

        this.toggleSubmitButton();

        return true;
    }

    toggleSubmitButton() {

        const hasErrors = this.form.querySelector('.form-group.has-error');

        if (!this.submitButton) {
            return;
        }

        this.submitButton.disabled = !!hasErrors;

    }

    generateUUID() {
        if (
            window.crypto &&
            typeof window.crypto.randomUUID === 'function'
        ) {
            return window.crypto.randomUUID();
        }

        if (
            window.crypto &&
            typeof window.crypto.getRandomValues === 'function'
        ) {
            const bytes = new Uint8Array(16);

            window.crypto.getRandomValues(bytes);

            bytes[6] = (bytes[6] & 0x0f) | 0x40;
            bytes[8] = (bytes[8] & 0x3f) | 0x80;

            const hex = [];

            for (let i = 0; i < bytes.length; i++) {
                hex.push((bytes[i] + 0x100).toString(16).slice(1));
            }

            return (
                hex[0] + hex[1] + hex[2] + hex[3] + '-' +
                hex[4] + hex[5] + '-' +
                hex[6] + hex[7] + '-' +
                hex[8] + hex[9] + '-' +
                hex[10] + hex[11] + hex[12] + hex[13] + hex[14] + hex[15]
            );
        }

        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
            const r = Math.floor(Math.random() * 16);
            const v = c === 'x' ? r : (r & 0x3) | 0x8;

            return v.toString(16);
        });
    }

    injectEventId() {
        let input = this.form.querySelector('input[name="event_id"]');

        if (!input) {
            input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'event_id';
            this.form.appendChild(input);
        }

        input.value = this.eventId;
    }

    injectCompanyDataField() {

        let input = this.form.querySelector('[name="company_data"]');

        if (!input) {
            input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'company_data';

            this.form.appendChild(input);
        }

        this.companyDataField = input;

    }

    onSubmitSuccess() {
        window.dataLayer = window.dataLayer || [];

        window.dataLayer.push({
            event: 'demo_request',
            event_id: this.eventId,
            form_id: 'demo-request',
            form_location: window.location.href,
        });

        this.form.reset();

        this.formWrapper.classList.add('is-hidden');

        if (this.successBlock) {
            this.successBlock.classList.remove('is-hidden');
        }
    }

    onSubmitError(error) {
        console.error('Form submit error:', error);

        if (this.submitButton) {
            this.submitButton.disabled = false;
            this.submitButton.textContent = 'Try again';
        }
    }

    onCompanyInput(value) {

        this.companySelected = false;
        this.selectedCompany = null;

        this.orgNumberField.value = '';

        this.hideError(this.companyField);
        this.hideError(this.orgNumberField);

        this.hideOrgNumberField();

        clearTimeout(this.companySearchTimeout);

        value = value.trim();

        if (value.length < 2) {
            this.hideCompanies();

            return;
        }

        this.companySearchTimeout = setTimeout(() => {
            this.searchCompanies(value);
        }, 350);
    }

    handleCompanyBlur() {
        const value = this.companyField.value.trim();

        if (!value || this.companySelected) {
            return;
        }

        const activeElement = document.activeElement;

        if (
            activeElement &&
            (
                activeElement.hasAttribute('data-company-item') ||
                activeElement.hasAttribute('data-company-custom')
            )
        ) {
            return;
        }

        this.useCustomCompany();
    }

    async searchCompanies(searchTerm) {

        if (this.searchController) {
            this.searchController.abort();
        }

        this.searchController = new AbortController();

        this.showCompanyLoader();

        try {

            this.showCompanyLoader();

            const response = await fetch(
                `${themeVars.home}/wp-json/company_search/v2/data?searchTerm=${encodeURIComponent(searchTerm)}`,
                {
                    signal: this.searchController.signal,
                }
            );

            if (!response.ok) {
                throw new Error('Search failed');
            }

            const data = await response.json();

            this.renderCompanies(
                Array.isArray(data.companies) ? data.companies : [],
                searchTerm
            );

        } catch (error) {

            if (error.name !== 'AbortError') {
                console.error(error);

                // In case of network problems, we still give the user the option to use the entered name.
                this.renderCompanies([], searchTerm);
            }

        } finally {

            this.hideCompanyLoader();

        }

    }

    renderCompanies(companies, searchTerm) {

        if (!this.companySuggestions) {
            return;
        }

        const useInsteadText = this.translate('useInstead', {
            value: searchTerm,
        });

        const suggestions = document.createDocumentFragment();

        companies.forEach((company, index) => {

            const item = document.createElement('div');
            item.className = 'company-suggestion';
            item.setAttribute('data-company-item', '');
            item.dataset.companyIndex = index;
            item.tabIndex = 0;

            const title = document.createElement('div');
            title.className = 'company-suggestion__title';
            title.setAttribute('data-company-title', '');
            title.textContent = company.label || '';

            const description = document.createElement('div');
            description.className = 'company-suggestion__description';
            description.setAttribute('data-company-description', '');
            description.textContent = company.location || '';

            item.appendChild(title);
            item.appendChild(description);
            suggestions.appendChild(item);

        });

        const custom = document.createElement('div');
        custom.className = 'company-suggestion company-suggestion--custom';
        custom.setAttribute('data-company-custom', '');
        custom.tabIndex = 0;
        custom.textContent = useInsteadText;
        suggestions.appendChild(custom);

        this.companySuggestions.textContent = '';
        this.companySuggestions.appendChild(suggestions);
        this.companySuggestions.classList.add('is-open');

        this.bindCompanySuggestions(companies);
        this.bindCompanyKeyboard();

    }

    bindCompanySuggestions(companies) {

        this.companySuggestions
            .querySelectorAll('[data-company-index]')
            .forEach((item) => {

                item.addEventListener('click', () => {

                    const company = companies[item.dataset.companyIndex];

                    this.selectCompany(company);

                });

            });

        const custom = this.companySuggestions.querySelector('[data-company-custom]');

        if (custom) {
            custom.addEventListener('click', () => {
                this.useCustomCompany();
            });
        }

    }

    bindCompanyKeyboard() {

        const items = this.companySuggestions.querySelectorAll(
            '[data-company-item], [data-company-custom]'
        );

        items.forEach((item, index) => {

            item.addEventListener('keydown', (e) => {

                switch (e.key) {

                    case 'ArrowDown':

                        e.preventDefault();

                        if (items[index + 1]) {
                            items[index + 1].focus();
                        }

                        break;

                    case 'ArrowUp':

                        e.preventDefault();

                        if (items[index - 1]) {
                            items[index - 1].focus();
                        } else {
                            this.companyField.focus();
                        }

                        break;

                    case 'Enter':

                        e.preventDefault();
                        item.click();

                        break;

                    case 'Escape':

                        this.hideCompanies();
                        this.companyField.focus();

                        break;

                }

            });

        });

    }

    selectCompany(company) {

        this.companySelected = true;
        this.selectedCompany = company;

        this.companyField.value = company.label;

        this.hideCompanies();

        this.hideError(this.companyField);

        this.loadCompanyDetails(company.data.duns);

    }

    async loadCompanyDetails(duns) {

        if (!duns) {
            return;
        }

        this.companyField.disabled = true;

        try {

            const response = await fetch(
                `${themeVars.home}/wp-json/company_search/v2/details?duns=${encodeURIComponent(duns)}`
            );

            if (!response.ok) {
                throw new Error('Failed to load company details');
            }

            const data = await response.json();

            this.fillCompanyDetails(data);

        } catch (error) {

            console.error(error);

        } finally {

            this.companyField.disabled = false;

        }

    }

    fillCompanyDetails(data) {

        if (!data) {
            return;
        }

        const registrationNumber = data.registration_number || '';

        this.orgNumberField.value = registrationNumber;

        if (registrationNumber) {
            this.hideOrgNumberField();
        } else {
            this.showOrgNumberField();

        }

        this.companyDataField.value = JSON.stringify({
            ...data,
            registration_number: registrationNumber,
        });
    }

    useCustomCompany() {

        this.companySelected = false;
        this.selectedCompany = null;

        this.orgNumberField.value = '';
        this.showOrgNumberField();

        this.companyDataField.value = JSON.stringify({
            company_name: this.companyField.value.trim(),
            registration_number: '',
            is_custom: true,
        });

        this.hideCompanies();

        this.hideError(this.companyField);
    }

    showOrgNumberField() {

        if (!this.orgNumberGroup) {
            return;
        }

        this.orgNumberGroup.classList.remove('is-hidden');
        this.orgNumberGroup.classList.add('is-required');
        this.orgNumberField.required = true;
    }

    hideOrgNumberField() {

        if (!this.orgNumberGroup) {
            return;
        }

        this.orgNumberGroup.classList.add('is-hidden');
        this.orgNumberField.required = false;
        this.hideError(this.orgNumberField);
    }

    hideCompanies() {

        if (!this.companySuggestions) {
            return;
        }

        this.companySuggestions.innerHTML = '';
        this.companySuggestions.classList.remove('is-open');

    }

    translate(key, replacements = {}) {

        const translations = this.i18n[this.lang] || this.i18n.en;

        let text = translations[key] || this.i18n.en[key] || '';

        Object.keys(replacements).forEach((placeholder) => {
            text = text.replace(`{${placeholder}}`, replacements[placeholder]);
        });

        return text;

    }

    showCompanyLoader() {

        if (!this.companyGroup) {
            return;
        }

        this.companyGroup.classList.add('is-loading');

    }

    hideCompanyLoader() {

        if (!this.companyGroup) {
            return;
        }

        this.companyGroup.classList.remove('is-loading');

    }

    getRequiredFields() {
        return [
            ...this.form.querySelectorAll(
                '.form-group.is-required input, .form-group.is-required select'
            ),
        ];
    }

    validateCompany(field, value) {

        if (!value) {
            return this.showError(field);
        }

        return this.hideError(field);

    }

    setSubmitting(isSubmitting) {

        this.formWrapper.classList.toggle('is-submitting', isSubmitting);

        this.form
            .querySelectorAll('input, select, textarea, button')
            .forEach((field) => {
                field.disabled = isSubmitting;
            });

    }
}

export default HeroDemoForm;



// WEBPACK FOOTER //
// ./scripts/modules/HeroDemoForm.js